module.exports = __webpack_public_path__ + "img/violet_102.d48e29e8.png";